
import ScorecardProfileImage from '@/components/Scorecard/ScorecardProfileImage.vue'
import { ScorecardEntity } from '@/entities/scorecard'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 's-vuex-class'
import { decode } from 'he'

@Component({
    components: {
        ScorecardProfileImage,
    },
})
export default class ScorecardProfile extends Vue {
    @Getter
    scorecard?: ScorecardEntity

    @Getter
    locationText!: string

    get name() {
        return decode(this.scorecard?.user.name || '')
    }
}
